export interface Input {
  site?: string;
}
interface State {}
export default class AppHeader extends Marko.Component<Input, State> {}
